import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App.jsx';
import { captureInstallPrompt } from './app/durability.js';
import { installFonts } from './app/fonts.js';
import './styles.css';

installFonts();
captureInstallPrompt();
// Offline app shell (M1.4); autoUpdate keeps the precache fresh in place.
registerSW({ immediate: true });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
